import { $fetch, $post } from '@/services/axios';

export function fetch(params) {
  return $fetch(`operator/operator/sessions`, params);
}

export function logout(id) {
  return $post(`operator/operator/session/logout`, { id });
}
